import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { InfoPessoalPage } from './info-pessoal.page';

const routes: Routes = [
  {
    path: '',
    component: InfoPessoalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InfoPessoalPageRoutingModule {}
